<template>
    <Head>
        <title>Product Distributors | NutriStudents K-12</title>
        <meta name="description" content="Product Distributors" />
    </Head>
    <default-layout>
        <BreadcrumLayout>

        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="lg:mb-0 mb-4 w-1/2">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold">
                    Product Distributors
                </h1>
            </div>
            <div
                class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center"
            >
                <button>
                    <inertia-link
                        :href="route('add-product-distributor')"
                        class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 mt-10 inline-block"
                    >
                        CREATE NEW DISTRIBUTOR
                    </inertia-link>
                </button>
            </div>
        </PageTitleLayout>

        <TableFilterLayout @messageFromChild="distributorSearchData" />

        <TableIndexLayout>
            <div class="-my-2">
                <div
                    class="py-2 align-middle inline-block xl:px-10 px-5 w-full"
                >
                    <div class="shadow overflow-x-auto">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr>
                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        DISTRIBUTOR NAME
                                    </th>

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    ></th>

                                    <th
                                        scope="col"
                                        class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                                    >
                                        Last Updated
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="!distributors.length"
                                    class="bg-white"
                                >
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color text-center"
                                        colspan="7"
                                    >
                                        No Distributor Found
                                    </td>
                                </tr>

                                <!-- Odd row -->
                                <tr
                                    v-for="(distributor, index) in distributors"
                                    :class="{
                                        'bg-white': index % 2 == 0,
                                        'tr-background-color': index % 2 != 0,
                                    }"
                                >
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >
                                        {{ distributor.name }}
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold"
                                    >
                                        <inertia-link
                                            :href="
                                                route(
                                                    'edit-product-distributor',
                                                    { id: distributor.id }
                                                )
                                            "
                                            class=""
                                        >
                                            <i
                                                class="fa fa-pencil-square-o pr-3"
                                                aria-hidden="true"
                                            ></i>
                                        </inertia-link>

                                        <button
                                            @click="
                                                openImportProductModal(index)
                                            "
                                        >
                                            <i
                                                class="fa fa-file-excel-o pr-3"
                                                aria-hidden="true"
                                            ></i>
                                        </button>

                                        <inertia-link
                                            :href="
                                                route(
                                                    'product-distributor-products',
                                                    { id: distributor.id }
                                                )
                                            "
                                            class=""
                                        >
                                            <i
                                                class="fa fa-eye pr-3"
                                                aria-hidden="true"
                                            ></i>
                                        </inertia-link>

                                        <button
                                            v-if="distributor.is_tenant_admin"
                                            type="button"
                                            @click="
                                                distributor_delete_script(
                                                    distributor.id
                                                )
                                            "
                                            class=""
                                        >
                                            <i
                                                class="fa fa-trash"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                                    >{{ distributor.last_updated }}

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-12 flex justify-end pr-10 w-full mb-8">
                <button>
                    <inertia-link
                        :href="route('add-product-distributor')"
                        class="button-color text-white font-bold py-1.5 px-4 mb- rounded focus:outline-none inline-block"
                    >
                        CREATE NEW DISTRIBUTOR
                    </inertia-link>
                </button>
            </div>
        </TableIndexLayout>
    </default-layout>

    <jet-dialog-modal :show="importProductsModal" :max-width="'3xl'">
        <template #title>
            <div class="flex justify-between items-center"></div>
        </template>

        <template #content>
            <TableIndexLayout>
                <form
                    action="#"
                    @submit.prevent="false"
                    enctype="multipart/form-data"
                    ref="form_1"
                >
                    <div class="-my-2">
                        <div class="py-2 align-middle inline-block px-2 w-full">
                            <div class="shadow overflow-x-auto">
                                <div class="w-full">
                                    <div
                                        class="xl:grid xl:gap-1 xl:grid-cols-3 block items-center pl-5 mt-3"
                                    >
                                        <label class="font-bold text-gray-700"
                                            >CSV to Distributor Products
                                            *</label
                                        >
                                        <div>
                                            <!-- <input type="file" @change="handleFileUpload()" id="file" name="file" ref="file" class="xl:mt-0 mt-4 sm:w-64 w-48 shadow-sm focus:border-none block sm:text-sm border p-1 border-gray-300 rounded-lg select-menu-height input-background" required accept=".xlsx, .xls, .csv" /> -->

                                            <input
                                                type="file"
                                                v-on:change="
                                                    onProuductsyncImport
                                                "
                                                id="file"
                                                name="file"
                                                ref="file"
                                                class="xl:mt-0 mt-4 sm:w-64 w-48 shadow-sm focus:border-none block sm:text-sm border p-1 border-gray-300 rounded-lg select-menu-height input-background"
                                                required
                                                accept=".xlsx, .xls, .csv"
                                            />

                                            <div
                                                v-if="form.errors.file"
                                                class="validation_error_msg"
                                            >
                                                {{ form.errors.file }}
                                            </div>
                                            <div class="flex justify-end">
                                                <a
                                                    :href="$page.props.asset_url + '/sample.csv'"
                                                    class="underline mt-1 text-blue-500"
                                                    download
                                                    >Sample File</a
                                                >
                                            </div>
                                            <!-- <div class="loader-15"></div> -->
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </TableIndexLayout>
        </template>

        <template #footer>
            <jet-secondary-button :disabled="!enableImport" @click="importProducts()"
                >Import Products</jet-secondary-button
            >
            <jet-secondary-button
                @click="importProductsModal = false"
                class="ml-4"
                >Close</jet-secondary-button
            >
        </template>
    </jet-dialog-modal>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";

export default {
    props: ["all_distributors"],
    components: {
        DefaultLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        JetDialogModal,
        JetSecondaryButton,
    },
    data() {
        return {
            distributors: this.all_distributors,
            form: this.$inertia.form({
                file: "",
                distributor_id: "",
            }),
            importProductsModal: false,
            enableImport: false
        };
    },
    methods: {
        onProuductsyncImport(e) {
            this.enableImport = false;
            let img_file = e.target.files || e.dataTransfer.files;
            if (!img_file.length) {
                return;
            } else {
                // this.uploadProgress = true;
                let $this = this;
                Vapor.store(e.target.files[0], {
                    // visibility: 'public-read',
                    progress: (progress) => {},
                }).then((response) => {
                    // $this.uploadProgress = false;
                    $this.form.file = response;
                    this.enableImport = true;
                    console.log("vapor response", response);
                });
            }
        },

        handleFileUpload(e) {
            const file = event.target.files[0];
            console.log(file);
            if (file) {
                this.form.file = file;
            }
        },

        // onChangeFile(){

        // },

        // onProuductsyncImport(e) {
        // let img_file = e.target.files || e.dataTransfer.files;
        //     if (!img_file.length) {
        //         return;
        //     } else {
        //         // this.uploadProgress = true;
        //         let $this = this;
        //         Vapor.store(e.target.files[0], {
        //         // visibility: 'public-read',
        //         progress: (progress) => {},
        //         }).then((response) => {
        //         // $this.uploadProgress = false;
        //         $this.form.file = response;
        //         console.log("vapor response", response);
        //         });
        //     }
        // },

        openImportProductModal(index) {
            console.log("Distributor_id", this.distributors[index].id);
            this.form.distributor_id = this.distributors[index].id;
            // this.distributor_id = this.distributors[index];
            this.importProductsModal = true;
        },

        importProducts() {
            this.form.post(this.route("import-distributor-products"), {
                onSuccess: () => {
                    this.importProductsModal = false;
                    this.$refs.form_1.reset();
                    this.$toast.success("Imported Successfully!");
                },
            });

            // console.log('yess');
        },

        distributor_delete_script(distributorid) {
            if (confirm("Are you sure you want to delete this distributor?")) {
                this.form.post(
                    this.route("delete-product-distributor", distributorid),
                    {
                        onSuccess: () => {
                            this.$toast.success(
                                "Distributor deleted successfully!"
                            );
                            let index = this.distributors.findIndex(item => item.id == distributorid);
                            if(index != -1){
                                this.distributors.splice(index, 1);
                            }
                            // setTimeout(function () {
                            //     window.location.reload();
                            // }, 1000);
                        },
                    }
                );
            }
        },

        distributorSearchData(search) {
            if (search == "") {
                this.distributors = this.all_distributors;
                // this.$toast.error('Error: Search value required!');
                // return false;
            } else {
                axios
                    .post("/search-product-distributor", {
                        term: search,
                    })
                    .then((response) => {
                        this.distributors = response.data;
                    })
                    .catch((error) => console.error(error));
            }
        },
    },
};
</script>

<style>
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 17px;
    left: 43px;
    padding-left: 7px;
    color: #219fd5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219fd5;
    padding-left: 7px;
    position: absolute;
    top: 17px;
    left: 43px;
}
</style>
